// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2w18y","col":"Table_col__12IWu","fulfillmentStatus":"Table_fulfillmentStatus__23kVI","emailCol":"Table_emailCol__W-TXQ"};